"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.organizationFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    address_1: '1234 Main St',
    address_2: 'Suite 100',
    admin_email: mocks_1.persona.email,
    admin_first_name: mocks_1.persona.first_name,
    admin_last_name: mocks_1.persona.last_name,
    admin_phone: mocks_1.persona.phone,
    admin_role: 'Leader',
    billing_account_id: 123,
    city: 'Mpls',
    claimed_by_user_id: 1,
    color: 'Organge',
    contact_information: '',
    country: 'USA',
    created_at: mocks_1.dates.date2000,
    deleted_at: null,
    description: 'test org',
    email: mocks_1.persona.email,
    external_references: [],
    guid: null,
    logo: {
        is_default: true,
        url: null,
        filename: null,
        filetype: null,
        large_logo_url: null,
        medium_logo_url: null,
        small_logo_url: null,
        tiny_logo_url: null
    },
    name: 'Test Organization',
    notes: null,
    organization_types: null,
    phone: mocks_1.persona.phone,
    postal_code: '55555',
    processing_fee: null,
    salesforce_crm_id: null,
    searchable: true,
    service_latitude: null,
    service_longitude: null,
    short_name: 'TstOrg',
    social_media_urls: {
        facebook: null,
        instagram: null,
        twitter: null,
        youtube: null
    },
    sports: [],
    state: 'MN',
    status: 'active',
    team_processing_fee: null,
    team_transaction_fee: null,
    timezone: 'America/Chicago',
    transaction_fee: null,
    updated_at: mocks_1.dates.date2000,
    vector_logo_url: null,
    website_url: null,
});
